import React, { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

// Components

import UniversalInput from '@lib/wrappers/UniversalInput';

// Constants

import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';

// Types

import { IExchangeProgramNames, SsapData } from '../../../SsapTypes';

interface ICoverageEndAttestation {
    actions: {
        onFieldChange_data: Function
    },
    data: SsapData,
    exchangeAndProgramNames: IExchangeProgramNames,
    formName: string,
    isAsteriskShown: boolean
}

const CoverageEndAttestation = (props: ICoverageEndAttestation): ReactElement => {
    const {
        actions: {
            onFieldChange_data
        },
        data,
        data: {
            agreeToEndCoverage
        },
        exchangeAndProgramNames: {
            exchangeName,
            exchangeMedicaid
        },
        formName,
        isAsteriskShown = true
    } = props;


    const className = classNames({
        'required-true': isAsteriskShown
    });

    return (
        <UniversalInput
            label = { {
                text: 'common.input.label.non_internationalized_text',
                labelTextReplacements: {
                    text: (
                        <span className = { className } >
                            <FormattedMessage
                                id = 'ssap.input.label.agree_to_end_coverage'
                                values = { {
                                    exchangeName,
                                    exchangeMedicaid
                                } }
                            />
                        </span>
                    )
                }
            } }
            inputData = { {
                isInputRequired: true,
                type: INPUT_TYPES.CHECKBOX,
                name: 'agreeToEndCoverage',
                classes: [ 'disp-styl' ],
                checked: agreeToEndCoverage,
                value: agreeToEndCoverage,
                validationType: VALIDATION_TYPES.CHECKED,
                currentData: data,
                fields: [ ]
            } }
            errorClasses = { [ 'margin-l-0' ] }
            inputActions = { {
                onFieldChange: onFieldChange_data
            } }
            underFormControl
            parentForm = { { name: formName } }
        />
    );
};

export default CoverageEndAttestation;